
export const INIT_DISCOVERY = 'INIT_DISCOVERY'
export const REFETCH_DISCOVERY_SET = 'REFETCH_DISCOVERY_SET'
export const SAVE_DISCOVERY_SET_REQUEST = 'SAVE_DISCOVERY_SET_REQUEST'
export const SAVE_DISCOVERY_SET_SUCCESS = 'SAVE_DISCOVERY_SET_SUCCESS'
export const SAVE_DISCOVERY_SET_FAILURE = 'SAVE_DISCOVERY_SET_FAILURE'
export const FETCH_DISCOVERY_SET_REQUEST = 'FETCH_DISCOVERY_SET_REQUEST'
export const FETCH_DISCOVERY_SET_SUCCESS = 'FETCH_DISCOVERY_SET_SUCCESS'
export const FETCH_DISCOVERY_SET_FAILURE = 'FETCH_DISCOVERY_SET_FAILURE'
export const RESET_DISCOVERY_SET = 'RESET_DISCOVERY_SET'
export const SET_RESET_DISCOVERY_SET_LOADING = 'SET_RESET_DISCOVERY_SET_LOADING'
export const SAVE_RESET_DISCOVERY_SET_REQUEST = 'SAVE_RESET_DISCOVERY_SET_REQUEST'
export const SAVE_RESET_DISCOVERY_SET_SUCCESS = 'SAVE_RESET_DISCOVERY_SET_SUCCESS'
export const SAVE_RESET_DISCOVERY_SET_FAILURE = 'SAVE_RESET_DISCOVERY_SET_FAILURE'
export const FETCH_FIRM_REQUEST = 'FETCH_FIRM_REQUEST'
export const FETCH_FIRM_SUCCESS = 'FETCH_FIRM_SUCCESS'
export const FETCH_FIRM_FAILURE = 'FETCH_FIRM_FAILURE'
export const FETCH_INVITE_REQUEST = 'FETCH_INVITE_REQUEST'
export const FETCH_INVITE_SUCCESS = 'FETCH_INVITE_SUCCESS'
export const FETCH_INVITE_FAILURE = 'FETCH_INVITE_FAILURE'
export const FETCH_CARDS_REQUEST = 'FETCH_CARDS_REQUEST'
export const FETCH_CARDS_SUCCESS = 'FETCH_CARDS_SUCCESS'
export const FETCH_CARDS_FAILURE = 'FETCH_CARDS_FAILURE'
export const FETCH_ANSWERS_REQUEST = 'FETCH_ANSWERS_REQUEST'
export const FETCH_ANSWERS_SUCCESS = 'FETCH_ANSWERS_SUCCESS'
export const FETCH_ANSWERS_FAILURE = 'FETCH_ANSWERS_FAILURE'
export const LOAD_CARDS = 'LOAD_CARDS'
export const LOAD_ANSWERS = 'LOAD_ANSWERS'
export const PROCESSED_DISCOVERY_SET = 'PROCESSED_DISCOVERY_SET'
export const UPDATE_GRID_TOOL_PROGRESS = 'UPDATE_GRID_TOOL_PROGRESS'
export const UPDATE_MONEY_FOCUS_TOOL_PROGRESS = 'UPDATE_MONEY_FOCUS_TOOL_PROGRESS'
export const UPDATE_DECISION_FOCUS_TOOL_PROGRESS = 'UPDATE_DECISION_FOCUS_TOOL_PROGRESS'
export const UPDATE_HEALTH_AND_HAPPINESS_FOCUS_TOOL_PROGRESS = 'UPDATE_HEALTH_AND_HAPPINESS_FOCUS_TOOL_PROGRESS'

export const RESET_FOCUS_TOOL_PROGRESS = 'RESET_FOCUS_TOOL_PROGRESS'
export const SET_RESET_FOCUS_TOOL_LOADING = 'SET_RESET_FOCUS_TOOL_LOADING'
export const RESET_FOCUS_TOOL_PROGRESS_REQUEST = 'RESET_FOCUS_TOOL_PROGRESS_REQUEST'
export const RESET_FOCUS_TOOL_PROGRESS_SUCCESS = 'RESET_FOCUS_TOOL_PROGRESS_SUCCESS'
export const RESET_FOCUS_TOOL_PROGRESS_FAILURE = 'RESET_FOCUS_TOOL_PROGRESS_FAILURE'

export const CLIENT_DETAIL_CHANGE = 'CLIENT_DETAIL_CHANGE'
export const SAVE_CLIENT_REQUEST = 'SAVE_CLIENT_REQUEST'
export const SAVE_CLIENT_SUCCESS = 'SAVE_CLIENT_SUCCESS'
export const SAVE_CLIENT_FAILURE = 'SAVE_CLIENT_FAILURE'
export const SAVE_CLIENT_ENQUIRY_REQUEST = 'SAVE_CLIENT_ENQUIRY_REQUEST'
export const SAVE_CLIENT_ENQUIRY_SUCCESS = 'SAVE_CLIENT_ENQUIRY_SUCCESS'
export const SAVE_CLIENT_ENQUIRY_FAILURE = 'SAVE_CLIENT_ENQUIRY_FAILURE'

export const SAVE_INVITE_CONVERSION_REQUEST = 'SAVE_INVITE_CONVERSION_REQUEST'
export const SAVE_INVITE_CONVERSION_SUCCESS = 'SAVE_INVITE_CONVERSION_SUCCESS'
export const SAVE_INVITE_CONVERSION_FAILURE = 'SAVE_INVITE_CONVERSION_FAILURE'

export const CLEAR_INVITE_ID = 'CLEAR_INVITE_ID'



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/modules/constants.js
 **/